import { useIsBrowser } from 'util/useIsBrowser';
import styles from './styles.module.scss';

interface Props {
  title?:string;
  description?:string | {
    dangerouslySetInnerHTML: {
      __html: string;
    };
  }
}

export const SectionHeader = ({ title, description }:Props) => {
  const isBrowser = useIsBrowser();
  return (
    <>
      {title && <h3 className={styles.section_header}>{title}</h3>}
      {typeof description === 'string' && (
      <p className={styles.section_description}>
        {description}
      </p>
      )}
      {description && typeof description !== 'string' && isBrowser && (
      <div
        className={styles.section_description}
        dangerouslySetInnerHTML={description.dangerouslySetInnerHTML}
      />
      ) }
    </>
  );
};
